import "./Tabs.scss";

import React from "react";
import cx from "classnames";

export type Tab = {
  id: string;
  label: React.ReactNode;
  content: React.ReactNode;
};

type TabsProps = {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
};

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
}) => {
  return (
    <div className={cx("tabs-container", className)}>
      <div className="tabs-nav">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={cx("tab-button", { active: activeTab === tab.id })}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tab-content">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};

export default Tabs;
